import React, { forwardRef, useImperativeHandle, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import styles from './Modal.css';

const Modal = forwardRef((props, ref) => {
  const [state, setState] = useState({
    visible: false,
    children: null,
    renderHtml: true,
    bodyStyle: null,
    textConfirm: 'Aceptar',
    showConfirm: true,
    actionConfirm: null,
    textCancel: 'Cerrar',
    showCancel: false,
    actionCancel: null,
  });

  useImperativeHandle(ref, () => ({
    // eslint-disable-next-line no-use-before-define
    showModal: show,
    // eslint-disable-next-line no-use-before-define
    hideModal: close,
  }));

  const show = (
    title, children, renderHtml, bodyStyle, textConfirm, showConfirm,
    actionConfirm, textCancel, showCancel, actionCancel,
  ) => {
    setState({
      visible: true,
      title,
      children,
      renderHtml,
      bodyStyle,
      textConfirm,
      showConfirm,
      actionConfirm,
      textCancel,
      showCancel,
      actionCancel,
    });
  };

  const close = () => {
    setState({
      visible: false,
      children: null,
      bodyStyle: null,
      textConfirm: 'Aceptar',
      showConfirm: true,
      actionConfirm: null,
      textCancel: 'Cerrar',
      showCancel: false,
      actionCancel: null,
    });
    const { actionCancel } = state;
    if (actionCancel) {
      actionCancel();
    }
  };

  const confirm = () => {
    setState({
      visible: false,
      children: null,
      bodyStyle: null,
      textConfirm: 'Aceptar',
      showConfirm: true,
      actionConfirm: null,
      textCancel: 'Cerrar',
      showCancel: false,
      actionCancel: null,
    });
    const { actionConfirm } = state;
    if (actionConfirm) {
      actionConfirm();
    }
  };

  return (
    state.visible &&
      <SweetAlert
        title={state.title}
        showConfirm={state.showConfirm}
        confirmBtnText={state.textConfirm}
        onConfirm={confirm}
        confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
        showCancel={state.showCancel}
        cancelBtnText={state.textCancel}
        cancelBtnCssClass={`${styles.btnNoAccept} ${styles.btn}`}
        onCancel={close}
        closeOnClickOutside={false}
        customClass={styles.modal_container}
        style={{
          width: '100%',
          left: 0,
          right: 0,
          maxWidth: state.width,
          margin: '0 auto',
          top: '10%',
        }}
      >
        <div style={{
          maxHeight: '300px',
          overflowY: 'auto',
          padding: '0 10px',
          textAlign: 'left',
        }}
        >
          {state.renderHtml ? <div dangerouslySetInnerHTML={{ __html: state.children }} /> :
            state.children
          }
        </div>
      </SweetAlert>);
});

export default Modal;



// WEBPACK FOOTER //
// ./src/common/global/modal/component/Modal.jsx